import { ProductSpec } from "../interface"

export const powerArQMini2: ProductSpec = {
  id: 'ac30',
  name: 'PowerArQ mini 2',
  url: process.env.GATSBY_TARGET_CHANNEL === 'rakuten' ? "https://item.rakuten.co.jp/kashima-tokeiten/ac30/" : "https://powerarq.com/collections/frontpage/products/ac30",
  capacity: 300,
  batteryType: 'リン酸鉄',
  colors: [
    'coyote-tan',
    'olive-drab',
    'red'
  ],
  defaultColor: 'coyote-tan',
  price: 44000,
  description: '防災性能に特化したminiシリーズの後継モデル。防災士監修の停電対策BOOKと、ライトにもなる簡易LEDランタン付き。',
  chargingTime: 5,
  chargingTimeWithSolar: { input: 80, value: 7 },
  chargingTimeWithCar: { input: 60, value: 9 },
  maximumOutput: 300,
  smartphone: 26,
  electricBlanket: 5,
  fan: 9,
  ledLight: 87,
  riceCooker: 1,
  projector: 4,
  fridge: 9,
  electricCarpet: 1,
  acPort: 2,
  usbA: 2,
  usbC: 1,
  qi: 1,
  builtInLed: 520,
  weight: 4.7
}